// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay-set {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-set {
  background-color: var(--bg-color);
  color: var(--bg-color);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  position: relative;
  max-width: 85%;
  width: 360px;
  overflow-y: auto;
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.x-button {
  color: var(--primary-text);
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 5px;
}

.modal-content-set {
  color: #f5deb3;
}

.modal-content-set h2 {
  font-size: 1.5rem;
  color: var(--primary-text);
  cursor: default;
  font-weight: var(--nunito-bold);
  margin-top: 30px;
  margin-bottom: 20px;
  letter-spacing: 5px;
}

.theme-setup,
.contrast-setup {
  border-bottom: 2px solid var(--secondary-text);
  margin-top: 20px;
}

.theme-setup-container,
.contrast-setup-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 400px;
  background-color: var(--bg-color);
  border-radius: 10px;
}

.theme-setup-text,
.contrast-setup-text {
  flex: 1 1;
}

.theme-setup-main-text,
.contrast-setup-main-text {
  font-size: 1.2rem;
  font-weight: bold;
  color: var(--primary-text);
}

.theme-setup-secondary-text,
.contrast-setup-secondary-text {
  font-size: 0.9rem;
  color: var(--secondary-text);
  text-align: left;
  padding: 5px 0px 10px 0px;
}

.theme-toggle,
.contrast-toggle {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.theme-toggle input,
.contrast-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.theme-toggle .slider,
.contrast-toggle .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--primary-text);
  transition: 0.4s;
  border-radius: 34px;
}

.theme-toggle .slider:before,
.contrast-toggle .slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: var(--bg-color);
  transition: 0.4s;
  border-radius: 50%;
}

.theme-toggle input:checked + .slider {
  background-color: var(--primary-text);
}

.theme-toggle input:focus + .slider {
  box-shadow: 0 0 1px var(--primary-text);
}

.theme-toggle input:checked + .slider:before {
  transform: translateX(26px);
  background-color: var(--alt-color);
}

.contrast-toggle input:checked + .slider {
  background-color: var(--secondary-text);
}

.contrast-toggle input:focus + .slider {
  box-shadow: 0 0 1px var(--primary-text);
}

.contrast-toggle input:checked + .slider:before {
  transform: translateX(26px);
  background-color: var(--bg-color);
}

.light-theme .contrast-toggle input:checked + .slider:before {
  background-color: var(--alt-color);
}

.game-setup {
  border-bottom: 2px solid var(--secondary-text);
  margin-top: 20px;
}

.game-setup-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 400px;
  background-color: var(--bg-color);
  border-radius: 10px;
}

.game-setup-text {
  flex: 1 1;
}

.game-setup-main-text {
  font-size: 1.2rem;
  font-weight: bold;
  color: var(--primary-text);
}

.game-setup-secondary-text {
  font-size: 0.9rem;
  color: var(--secondary-text);
  text-align: left;
  padding: 5px 0px 10px 0px;
}

.game-toggle {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.game-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.game-toggle .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--primary-text);
  transition: 0.4s;
  border-radius: 34px;
}

.game-toggle .slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: var(--bg-color);
  transition: 0.4s;
  border-radius: 50%;
}

.game-toggle input:checked + .slider {
  background-color: var(--secondary-text);
}

.game-toggle input:focus + .slider {
  box-shadow: 0 0 1px var(--primary-text);
}

.game-toggle input:checked + .slider:before {
  transform: translateX(26px);
  background-color: var(--bg-color);
}

.light-theme .game-toggle input:checked + .slider:before {
  background-color: var(--alt-color);
}

.toggle-message {
  font-size: 0.9rem;
  color: var(--secondary-text);
  text-align: left;
  padding: 5px 0px 10px 0px;
  font-weight: bold;
}

@media (hover: hover) {
  .x-button:hover {
    color: var(--secondary-text);
  }
}

@media screen and (max-width: 700px) {
  .modal-set {
    max-height: 72%;
    max-width: 80%;
    padding: 20px 20px 10px 20px;
  }

  .modal-content-set h2 {
    font-size: 1rem;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .theme-setup-main-text,
  .contrast-setup-main-text,
  .game-setup-main-text {
    font-size: 1.1rem;
  }

  .theme-setup-secondary-text,
  .contrast-setup-secondary-text,
  .game-setup-secondary-text {
    font-size: 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/settingsModal/SettingsModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;;EAEE,SAAO;AACT;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;IACd,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;;;IAGE,iBAAiB;EACnB;AACF","sourcesContent":[".modal-overlay-set {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.9);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.modal-set {\r\n  background-color: var(--bg-color);\r\n  color: var(--bg-color);\r\n  padding: 20px;\r\n  border-radius: 10px;\r\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);\r\n  position: relative;\r\n  max-width: 85%;\r\n  width: 360px;\r\n  overflow-y: auto;\r\n  animation: fadeIn 0.5s ease-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.95);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.x-button {\r\n  color: var(--primary-text);\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  padding: 5px;\r\n}\r\n\r\n.modal-content-set {\r\n  color: #f5deb3;\r\n}\r\n\r\n.modal-content-set h2 {\r\n  font-size: 1.5rem;\r\n  color: var(--primary-text);\r\n  cursor: default;\r\n  font-weight: var(--nunito-bold);\r\n  margin-top: 30px;\r\n  margin-bottom: 20px;\r\n  letter-spacing: 5px;\r\n}\r\n\r\n.theme-setup,\r\n.contrast-setup {\r\n  border-bottom: 2px solid var(--secondary-text);\r\n  margin-top: 20px;\r\n}\r\n\r\n.theme-setup-container,\r\n.contrast-setup-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  max-width: 400px;\r\n  background-color: var(--bg-color);\r\n  border-radius: 10px;\r\n}\r\n\r\n.theme-setup-text,\r\n.contrast-setup-text {\r\n  flex: 1;\r\n}\r\n\r\n.theme-setup-main-text,\r\n.contrast-setup-main-text {\r\n  font-size: 1.2rem;\r\n  font-weight: bold;\r\n  color: var(--primary-text);\r\n}\r\n\r\n.theme-setup-secondary-text,\r\n.contrast-setup-secondary-text {\r\n  font-size: 0.9rem;\r\n  color: var(--secondary-text);\r\n  text-align: left;\r\n  padding: 5px 0px 10px 0px;\r\n}\r\n\r\n.theme-toggle,\r\n.contrast-toggle {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 60px;\r\n  height: 34px;\r\n}\r\n\r\n.theme-toggle input,\r\n.contrast-toggle input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.theme-toggle .slider,\r\n.contrast-toggle .slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: var(--primary-text);\r\n  transition: 0.4s;\r\n  border-radius: 34px;\r\n}\r\n\r\n.theme-toggle .slider:before,\r\n.contrast-toggle .slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 26px;\r\n  width: 26px;\r\n  left: 4px;\r\n  bottom: 4px;\r\n  background-color: var(--bg-color);\r\n  transition: 0.4s;\r\n  border-radius: 50%;\r\n}\r\n\r\n.theme-toggle input:checked + .slider {\r\n  background-color: var(--primary-text);\r\n}\r\n\r\n.theme-toggle input:focus + .slider {\r\n  box-shadow: 0 0 1px var(--primary-text);\r\n}\r\n\r\n.theme-toggle input:checked + .slider:before {\r\n  transform: translateX(26px);\r\n  background-color: var(--alt-color);\r\n}\r\n\r\n.contrast-toggle input:checked + .slider {\r\n  background-color: var(--secondary-text);\r\n}\r\n\r\n.contrast-toggle input:focus + .slider {\r\n  box-shadow: 0 0 1px var(--primary-text);\r\n}\r\n\r\n.contrast-toggle input:checked + .slider:before {\r\n  transform: translateX(26px);\r\n  background-color: var(--bg-color);\r\n}\r\n\r\n.light-theme .contrast-toggle input:checked + .slider:before {\r\n  background-color: var(--alt-color);\r\n}\r\n\r\n.game-setup {\r\n  border-bottom: 2px solid var(--secondary-text);\r\n  margin-top: 20px;\r\n}\r\n\r\n.game-setup-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  max-width: 400px;\r\n  background-color: var(--bg-color);\r\n  border-radius: 10px;\r\n}\r\n\r\n.game-setup-text {\r\n  flex: 1;\r\n}\r\n\r\n.game-setup-main-text {\r\n  font-size: 1.2rem;\r\n  font-weight: bold;\r\n  color: var(--primary-text);\r\n}\r\n\r\n.game-setup-secondary-text {\r\n  font-size: 0.9rem;\r\n  color: var(--secondary-text);\r\n  text-align: left;\r\n  padding: 5px 0px 10px 0px;\r\n}\r\n\r\n.game-toggle {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 60px;\r\n  height: 34px;\r\n}\r\n\r\n.game-toggle input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.game-toggle .slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: var(--primary-text);\r\n  transition: 0.4s;\r\n  border-radius: 34px;\r\n}\r\n\r\n.game-toggle .slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 26px;\r\n  width: 26px;\r\n  left: 4px;\r\n  bottom: 4px;\r\n  background-color: var(--bg-color);\r\n  transition: 0.4s;\r\n  border-radius: 50%;\r\n}\r\n\r\n.game-toggle input:checked + .slider {\r\n  background-color: var(--secondary-text);\r\n}\r\n\r\n.game-toggle input:focus + .slider {\r\n  box-shadow: 0 0 1px var(--primary-text);\r\n}\r\n\r\n.game-toggle input:checked + .slider:before {\r\n  transform: translateX(26px);\r\n  background-color: var(--bg-color);\r\n}\r\n\r\n.light-theme .game-toggle input:checked + .slider:before {\r\n  background-color: var(--alt-color);\r\n}\r\n\r\n.toggle-message {\r\n  font-size: 0.9rem;\r\n  color: var(--secondary-text);\r\n  text-align: left;\r\n  padding: 5px 0px 10px 0px;\r\n  font-weight: bold;\r\n}\r\n\r\n@media (hover: hover) {\r\n  .x-button:hover {\r\n    color: var(--secondary-text);\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 700px) {\r\n  .modal-set {\r\n    max-height: 72%;\r\n    max-width: 80%;\r\n    padding: 20px 20px 10px 20px;\r\n  }\r\n\r\n  .modal-content-set h2 {\r\n    font-size: 1rem;\r\n    margin-top: 20px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .theme-setup-main-text,\r\n  .contrast-setup-main-text,\r\n  .game-setup-main-text {\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .theme-setup-secondary-text,\r\n  .contrast-setup-secondary-text,\r\n  .game-setup-secondary-text {\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
